module.exports = __webpack_public_path__ + "static/media/KW.95098ea1.svg";